import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/crown.svg'
import _imports_1 from '@/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-9366fd3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "member-type" }
const _hoisted_6 = {
  key: 0,
  class: "owner",
  src: _imports_0
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-pills",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      id: "memberManageTab",
      class: "nav-link active",
      "data-bs-toggle": "tab",
      "data-bs-target": "#memberManagePane",
      role: "tab",
      "aria-controls": "memberManagePane",
      "aria-selected": "true"
    }, " Manage ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      id: "memberHistoryTab",
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#memberHistoryPane",
      role: "tab",
      "aria-controls": "memberHistoryPane",
      "aria-selected": "false"
    }, " History ")
  ])
], -1))
const _hoisted_9 = {
  key: 0,
  class: "tab-content content-area"
}
const _hoisted_10 = {
  id: "memberManagePane",
  class: "tab-pane show active",
  role: "tabpanel",
  "aria-labelledby": "memberManageTab",
  tabindex: "0"
}
const _hoisted_11 = { class: "form-check form-switch child-option" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "childCheck",
  class: "form-check-label"
}, " Enable child account features ", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text-sm" }, " Enable special features to protect children and their personal information. ", -1))
const _hoisted_15 = {
  id: "memberHistoryPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "memberHistoryTab",
  tabindex: "0"
}
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 4 }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_21 = { key: 5 }
const _hoisted_22 = ["disabled"]

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { Person } from '@/rd/ResearchDataModel'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useUserStore } from '@/gp/UserStore'
import { PotentialMember, potentialMemberIcons, useFamilyGroupMemberManager } from './FamilyGroupMemberManager'
import { hideModalAsync, useModalAutoHide } from '@/util/AppUtil'
import { useTokenManager } from '@/auth/TokenManager'
import { GroupMemberRole, PrincipalType, ItemPermissions, User, FamilyGroupMember } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { Modal as BsModal, Tab } from 'bootstrap'
import { PatchChange } from '@/util/Api'
import { useUserSupervisorStore } from '@/gp/UserSupervisorStore'
import FamilyGroupMemberHistory from './FamilyGroupMemberHistory.vue'
import FamilyGroupMemberManage from './FamilyGroupMemberManage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupMemberModal',
  props: {
    familyGroupId: {}
  },
  emits: ["shareProfile", "removeProfile", "invite", "removeUser", "addUser", "viewSharingInvite", "viewGroupInvite"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;



__expose({
  open,
  close,
})



const pmRef = ref<PotentialMember>()
const forProfileRef = ref(false)
const isChildRef = ref(false)
const showHistoryRef = ref(false)
const showChildOptionInfoRef = ref(false)
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()

const dataGroupStore = useDataGroupStore()
const userStore = useUserStore()
const familyGroupStore = useFamilyGroupStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const userSupervisorStore = useUserSupervisorStore()
const memberManager = useFamilyGroupMemberManager()
const tokenManager = useTokenManager()

// basic data objects
const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId)?.data) // loaded by parent
const profilePersonIdRef = computed(() => pmRef.value?.profileGroup?.startItemId)
const profileOwnerRef = computed(() => userStore.getAsyncUser(pmRef.value?.profileGroup?.ownerId)?.data)
const profileGroupMemberRef = computed(() => {
  // NOTE: Get reactive proxy from store so it will be updated if we share/unshare the profile
  return forProfileRef.value
    ? dataGroupMemberStore.getMembersForDataGroups([pmRef.value?.profileGroupId]).find(m => m.principalType == PrincipalType.FamilyGroup && m.principalId == props.familyGroupId) 
    : dataGroupMemberStore.getMembersForFamilyGroups([props.familyGroupId]).find(m => m.dataGroupId == pmRef.value?.profileGroupId)
})
const profilePermissionsRef = computed(() => dataGroupStore.getAsyncPermissions(pmRef.value?.profileGroupId, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const groupPermissionsRef = computed(() => familyGroupStore.getAsyncPermissions(props.familyGroupId)?.data ?? ItemPermissions.None) // loaded by parent
const supervisedUserIdsRef = computed(() => tokenManager.current.isSupervised ? [] : 
  userSupervisorStore.getForSupervisor(tokenManager.current.userId, LoadMode.EnsureLoaded).map(su => su.forUserId!))

// basic data conditions
const isProfileAdminRef = computed(() => (profilePermissionsRef.value & ItemPermissions.Modify) > 0)
const isUserSupervisorRef = computed(() => pmRef.value?.user && supervisedUserIdsRef.value.includes(pmRef.value.user.id!))
const canEditGroupRef = computed(() => (groupPermissionsRef.value & ItemPermissions.Modify) > 0)
const canAddMembersRef = computed(() => (groupPermissionsRef.value & ItemPermissions.AddItems) > 0)
const personIsDeceasedRef = computed(() => !!pmRef.value?.assumeDeceased)
const profileOwnedByGroupOwnerRef = computed(() => profileOwnerRef.value?.id == familyGroupRef.value?.ownerId)
const profileIsSharedRef = computed(() => !!profileGroupMemberRef.value)
const memIsGroupOwnerRef = computed(() => pmRef.value?.member?.role == GroupMemberRole.Owner)

// UI conditions and values
const memberTypeClassRef = computed(() => pmRef.value?.user ? 'user' : pmRef.value?.profileGroupId ? 'profile' : undefined)
const iconRef = computed(() => pmRef.value?.isSuggested ? potentialMemberIcons.suggested : potentialMemberIcons.person)

const memTypeNameRef = computed(() => pmRef.value?.member?.role == GroupMemberRole.Owner ? "Group owner" : "Group member")

const allowedShareRef = computed(() => canAddMembersRef.value && (isProfileAdminRef.value || profileOwnedByGroupOwnerRef.value))

const canBeInvitedRef = computed(() => !pmRef.value?.profileGroup?.isChild && !pmRef.value?.member && !pmRef.value?.hasPendingGroupInvite && (pmRef.value?.user || (profileIsSharedRef.value && !pmRef.value?.assumeDeceased)))
const canInviteUserRef = computed(() => canBeInvitedRef.value && pmRef.value?.user && canAddMembersRef.value)
const canInviteRef = computed(() => canBeInvitedRef.value && (pmRef.value?.user ? canInviteUserRef : allowedShareRef.value))

const showChildOptionRef = computed(() => !pmRef.value?.user && !personIsDeceasedRef.value && allowedShareRef.value && profileIsSharedRef.value && !pmRef.value?.hasPendingGroupInvite)
const canAddUserRef = computed(() => isProfileAdminRef.value && !pmRef.value?.user && pmRef.value?.profileGroup?.isChild)

const canAddMemberRef = computed(() => profileIsSharedRef.value && !pmRef.value?.member && isUserSupervisorRef.value)

onBeforeUnmount(() => {
  close()
})

function open(pm: PotentialMember, forProfile = false) {
  pmRef.value = pm
  forProfileRef.value = forProfile

  isChildRef.value = pmRef.value?.profileGroup?.isChild ?? false
  showHistoryRef.value = true
  showChildOptionInfoRef.value = false

  // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
  // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
  BsModal.getOrCreateInstance(modalRef.value!).show()

  const memberManageTab = document.querySelector('#memberManageTab')!
  Tab.getOrCreateInstance(memberManageTab).show()
}

function close() {
  BsModal.getInstance(modalRef.value!)?.hide()
}

useModalAutoHide(modalRef)

watch(isChildRef, async () => {
  if (pmRef.value?.profileGroup && isChildRef.value != pmRef.value.profileGroup.isChild) {
    const change = new PatchChange('/isChild', isChildRef.value)
    await dataGroupStore.patchAsync(pmRef.value.profileGroupId!, [change])
  }
})

async function inviteShareProfile(profileGroupId?: string) {
  await hideModalAsync(modalRef.value!)
  emit('shareProfile', profileGroupId ?? pmRef.value!.profileGroupId!)
}

async function onRemoveProfile() {
  await hideModalAsync(modalRef.value!)
  emit('removeProfile', pmRef.value!)
}

async function onRemoveUser() {
  await hideModalAsync(modalRef.value!)
  emit('removeUser', pmRef.value!)
}

async function onAddMember() {
  try {
    busyRef.value = true

    const fm = new FamilyGroupMember()
    fm.familyGroupId = props.familyGroupId
    fm.userId = pmRef.value?.user?.id
    fm.role = GroupMemberRole.Member
    await familyGroupMemberStore.addAsync(fm)
  }
  finally {
    busyRef.value = false
  }
}

async function onInvite() {
  await hideModalAsync(modalRef.value!)
  emit('invite', pmRef.value!)
}

async function onAddUser() {
  await hideModalAsync(modalRef.value!)
  emit('addUser', pmRef.value!)
}

async function onViewSharingInvite() {
  await hideModalAsync(modalRef.value!)
  emit('viewSharingInvite', pmRef.value!.lastSharingInvite!.id!)
}

async function onViewGroupInvite(inviteId: string) {  
  await hideModalAsync(modalRef.value!)
  emit('viewGroupInvite', inviteId)
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal member-modal",
    ref_key: "modalRef",
    ref: modalRef,
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: _normalizeClass(["member-icon", memberTypeClassRef.value]),
            src: iconRef.value
          }, null, 10, _hoisted_4),
          _createElementVNode("h1", null, _toDisplayString(pmRef.value?.displayName), 1),
          _createElementVNode("button", _mergeProps({
            type: "button",
            class: "btn-close"
          }, { disabled: busyRef.value }, {
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }), null, 16),
          _createElementVNode("div", _hoisted_5, [
            (memIsGroupOwnerRef.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            (pmRef.value?.member)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(memTypeNameRef.value), 1)
                ], 64))
              : (pmRef.value?.user)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" User ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(" Profile managed by " + _toDisplayString(profileOwnerRef.value?.displayName), 1)
                  ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (pmRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("section", _hoisted_10, [
                  _createVNode(FamilyGroupMemberManage, {
                    "family-group-id": _ctx.familyGroupId,
                    pm: pmRef.value,
                    onShareProfile: inviteShareProfile,
                    onRemoveProfile: onRemoveProfile,
                    onRemoveUser: onRemoveUser
                  }, null, 8, ["family-group-id", "pm"]),
                  (showChildOptionRef.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "childCheck",
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChildRef).value = $event)),
                            disabled: !canEditGroupRef.value
                          }, null, 8, _hoisted_13), [
                            [_vModelCheckbox, isChildRef.value]
                          ])
                        ]),
                        _hoisted_14
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_15, [
                  _createVNode(FamilyGroupMemberHistory, {
                    "family-group-id": _ctx.familyGroupId,
                    pm: pmRef.value,
                    onViewSharingInvite: onViewSharingInvite,
                    onViewGroupInvite: onViewGroupInvite
                  }, null, 8, ["family-group-id", "pm"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (forProfileRef.value && familyGroupRef.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "btn btn-outline-primary secondary-action",
                to: familyGroupRef.value.pageUrl
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" View group ")
                ]),
                _: 1
              }, 8, ["to"]))
            : (pmRef.value?.user)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "btn btn-outline-primary secondary-action",
                  to: _unref(User).getPageUrl(pmRef.value.userId)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" View user ")
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (profilePersonIdRef.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    class: "btn btn-outline-primary secondary-action",
                    to: _unref(Person).getPageUrl(profilePersonIdRef.value)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" View profile ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
          (canAddMemberRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "btn btn-primary add-member",
                disabled: busyRef.value,
                onClick: onAddMember
              }, " Add as member ", 8, _hoisted_17))
            : _createCommentVNode("", true),
          (canInviteRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary invite",
                  disabled: busyRef.value,
                  onClick: onInvite
                }, [
                  _hoisted_20,
                  _createTextVNode(" Invite ")
                ], 8, _hoisted_19)
              ]))
            : _createCommentVNode("", true),
          (canAddUserRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: onAddUser
                }, " Create child account ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal"
          }, " Close ", 8, _hoisted_22)
        ])
      ])
    ])
  ], 512))
}
}

})